
import { RegenerateTokenDto } from '../../dto/regeneratetoken/regeneratetokendto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';


export interface RegenerateTokenRequest extends APIRequest
{
    getRegenerateTokenRequest(): RegenerateTokenDto;
}

export class RegenerateTokenRequestImpl extends APIRequestDtoImpl implements RegenerateTokenRequest
{
    constructor(private regenerateTokenData: RegenerateTokenDto)
    {
        super();
    }

    getRegenerateTokenRequest(): RegenerateTokenDto
    {
        return this.regenerateTokenData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/regeneratetoken/regeneratetokenrequest.tsx